import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  Badge,
  Card,
  Group,
  Text,
  SegmentedControl,
  Stack,
} from '@mantine/core';

import { PaginatedList } from '@components/shared';

const varietyColors = {
  1: 'green',
  2: 'teal',
  3: 'blue',
  4: 'indigo',
  5: 'orange',
};

export default function ApiUseList({
  items = null,
  refresh,
  requestInfo = {
    url: `/retrieve-api-uses/`,
    data: {},
  },
}) {
  const [filters, setFilters] = useState({ variety: 'entire' });

  const reqData = {
    ...filters,
    ...requestInfo.data,
    variety:
      filters.variety === 'entire' ? [1, 2, 3, 4, 5, 6] : filters.variety,
    refresh,
  };

  return (
    <div>
      <React.Fragment>
        <SegmentedControl
          value={filters.variety}
          my="xs"
          data={[
            { label: 'All', value: 'entire' },
            { label: 'Google Geocode', value: '1' },
            { label: 'Twilio Carrier Lookup', value: '2' },
            { label: 'Twilio Text Message', value: '3' },
            { label: 'Postmark Email', value: '4' },
            { label: 'Postmark Servers & Templates', value: '5' },
            { label: 'Validation Check', value: '6' },
          ]}
          onChange={(e) => setFilters({ ...filters, variety: e })}
        />
      </React.Fragment>
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: `/third-party-uses/${m.id}`,
          }))
        }
        displayFormatter={(item) => (
          <Card key={item.original.id}>
            <Stack gap={5}>
              <Group>
                <Text
                  size="md"
                  fw={700}
                  component={Link}
                  to={`/third-party-uses/${item.original.id}`}
                >
                  {item.original.title_string}
                </Text>
                <Text size="xs" c="dimmed">
                  {new Date(item.original.created_at).toLocaleDateString()}
                </Text>
              </Group>
              <Group>
                <Badge
                  variant="light"
                  p="sm"
                  color={varietyColors[item.original.variety]}
                >
                  {item.original.variety_formatted}
                </Badge>
                {item.original.context_formatted && (
                  <Badge color="gray" variant="light" size="sm">
                    {item.original.context_formatted.toUpperCase()}
                  </Badge>
                )}
              </Group>
            </Stack>
          </Card>
        )}
      />
    </div>
  );
}
